module.exports = __webpack_public_path__ + "static/media/favicon.d7f355c4.ico";